module.exports = __webpack_public_path__ + "img/handover_vendor_(hnd).146b7c14.svg";